import { useQuery } from "@tanstack/react-query";
import ConnectionsClient from "@/client/ConnectionsClient";

const connectionsClient = new ConnectionsClient();

export const getMutualConnections = (userId: string) =>
  useQuery({
    queryKey: ["getMutualConnections", userId],
    queryFn: () => connectionsClient.getUserMutualConnections(userId),
  });
